/**
 * Когда собрана работающая сейчас версия.
 *
 * Установленное на телефон приложение может держать в кеше вчерашнюю
 * сборку сутками: человек видит старое и считает, что починки не
 * случилось. Чтобы не гадать, дату видно в настройках.
 *
 * Значение подставляется при сборке — см. `define` в настройках сборщика.
 */
declare const __BUILT_AT__: string

export const builtAt: string = __BUILT_AT__
